module.exports = {

    pipeA: {
        texture: '/img/pipes/pipesA.jpg',
        scale: {
            x: '100%'
        }
    },

    pipeB: {
        scale: {
            x: '100%'
        },
        texture: '/img/pipes/pipesB.jpg',
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/pipes.js